// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"617":"80fb74b0","703":"2ff2a85d"}[chunkId] + ".chunk.js";
};